/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import React from 'react';

import TableErrorBoundary from './TableErrorBoundary';

function withErrorBoundaryHoc<P>(Component: React.ComponentType<P>) {
    const Wrapped: React.ComponentType<P> = props => {
        return <TableErrorBoundary>
            <Component {...props} />
        </TableErrorBoundary>;
    };

    const name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = `withErrorBoundary(${name})`;

    return Wrapped;
}

export default withErrorBoundaryHoc;
